import React, { useState } from "react";
import SavePaymentMethod from "../../components/Payment/SavePaymentMethod";
import DashboardHeader from "../../components/Shop/Layout/DashboardHeader";
import DashboardSideBar from "../../components/Shop/Layout/DashboardSideBar";
import ShopManagementPageHero from "../../components/Shop/Layout/ShopManagementPageHero";

const ShopChangePaymentMethodPage = () => {
  const [hasPaymentMethod, setHasPaymentMethod] = useState(false);
  const handlePaymentMethodRetrieved = (status) => {
    setHasPaymentMethod(status);
  };

  return (
    <div className="shop-management-page">
        <DashboardHeader />
        <div className="shop-management-layout">
          <div className="shop-management-sidebar-slot">
            <DashboardSideBar active={15} />
          </div>

          <main className="payment-method-page shop-management-main-panel">
            <ShopManagementPageHero
              eyebrow="Billing"
              title="Payment Methods"
              copy="Manage saved Stripe payment methods used for subscriptions and advertising."
            />
            <SavePaymentMethod onPaymentMethodRetrieved={handlePaymentMethodRetrieved} />
          </main>
        </div>
    </div>
  );
};

export default ShopChangePaymentMethodPage;